import { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";

export const formatoClp = (valor) =>
    valor == null || isNaN(valor)
        ? ""
        : `$${Math.round(valor).toLocaleString("es-CL")} CLP`;

export const formatoUf = (valor) =>
    valor == null || isNaN(valor)
        ? ""
        : valor.toLocaleString("es-CL", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
          }) + " UF";

const CalculadoraTarifaDialog = ({
    rowData,
    monedaOptions,
    onAplicar,
    onHide,
    usarCantidad = false,
    mostrarDiaria = false,
    mostrarDescuento = false,
    titulo = "Calcular Tarifa Base Cliente",
    etiquetaMonto = "Tarifa mensual deseada",
    etiquetaMensual = "Tarifa Mensual resultante",
}) => {
    const [monto, setMonto] = useState(null);
    const [moneda, setMoneda] = useState("CLP");

    useEffect(() => {
        if (rowData) {
            setMoneda(rowData.moneda);
            setMonto(null);
        }
    }, [rowData]);

    const valorUf = monedaOptions?.find((m) => m.codigo === "UF")?.tipoCambio || 1;

    const getTipoCambio = (codigo) =>
        monedaOptions?.find((m) => m.codigo === codigo)?.tipoCambio || 1;

    const divisor = usarCantidad ? rowData?.cantidad || 0 : 1;

    const tarifaCalculada =
        rowData && monto != null && divisor ? monto / divisor : null;

    const mensualUfCalc =
        tarifaCalculada != null && rowData
            ? (tarifaCalculada *
              getTipoCambio(moneda) *
              (usarCantidad ? rowData.cantidad : 1)) /
              valorUf
            : null;

    const diariaUfCalc = mensualUfCalc != null ? mensualUfCalc / 30 : null;

    const descuentoAplicado =
        tarifaCalculada != null && parseFloat(rowData?.tarifa_base) > 0
            ? -1 *
              ((tarifaCalculada - parseFloat(rowData.tarifa_base)) /
                  parseFloat(rowData.tarifa_base)) *
              100
            : null;

    return (
        <Dialog
            header={titulo}
            visible={!!rowData}
            style={{ width: "450px" }}
            modal
            onHide={onHide}
        >
            {rowData && (
                <div className="p-fluid">
                    <div className="field">
                        <label>{etiquetaMonto}</label>
                        <div style={{ display: "flex", gap: "0.5rem" }}>
                            <InputNumber
                                value={monto}
                                onValueChange={(e) => setMonto(e.value)}
                                locale="es-CL"
                                mode="decimal"
                                minFractionDigits={0}
                                maxFractionDigits={2}
                                autoFocus
                                style={{ flex: 1 }}
                            />
                            <Dropdown
                                value={moneda}
                                options={monedaOptions.filter(
                                    (item) => item.idEmpresa === rowData.id_empresa
                                )}
                                onChange={(e) => setMoneda(e.value)}
                                optionLabel="codigo"
                                optionValue="codigo"
                                placeholder="Moneda"
                                style={{ width: "9rem" }}
                            />
                        </div>
                    </div>
                    {/* {usarCantidad && (
                        <div className="field">
                            <label>Cantidad (metraje)</label>
                            <InputText value={rowData.cantidad ?? ""} disabled />
                        </div>
                    )} */}
                    {tarifaCalculada != null && (
                        <div
                            style={{
                                borderTop: "1px solid #dee2e6",
                                paddingTop: "0.75rem",
                                marginBottom: "0.75rem",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    marginBottom: "0.35rem",
                                }}
                            >
                                <span>Tarifa Base Cliente a aplicar:</span>
                                <strong>
                                    {tarifaCalculada.toLocaleString("es-CL", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    })}{" "}
                                    {moneda}
                                </strong>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    marginBottom: "0.35rem",
                                }}
                            >
                                <span>{etiquetaMensual}</span>
                                <span>
                                    {formatoUf(mensualUfCalc)}
                                    {moneda === "CLP" && (
                                        <div
                                            style={{
                                                fontSize: "0.85em",
                                                color: "#555",
                                                textAlign: "right",
                                            }}
                                        >
                                            {formatoClp(mensualUfCalc * valorUf)}
                                        </div>
                                    )}
                                </span>
                            </div>
                            {/* {mostrarDiaria && (
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        marginBottom: "0.35rem",
                                    }}
                                >
                                    <span>Tarifa Diaria resultante:</span>
                                    <span>{formatoUf(diariaUfCalc)}</span>
                                </div>
                            )}
                            {mostrarDescuento && (
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                    }}
                                >
                                    <span>Descuento resultante:</span>
                                    <span>
                                        {descuentoAplicado != null
                                            ? descuentoAplicado
                                                  .toFixed(2)
                                                  .replace(".", ",") + " %"
                                            : "-"}
                                    </span>
                                </div>
                            )} */}
                        </div>
                    )}
                    <div className="flex justify-content-end gap-2">
          
                        <Button
                            label="Aplicar"
                            icon="pi pi-check"
                            disabled={tarifaCalculada == null}
                            onClick={() => onAplicar(tarifaCalculada, moneda)}
                            autoFocus
                        />
                    </div>
                </div>
            )}
        </Dialog>
    );
};

export default CalculadoraTarifaDialog;
